import polyline from "@mapbox/polyline";
import Point from "@/geom/Point"
import BezierPathCommand from "@/geom/BezierPathCommand";

var BezierPathUtils = {
    createPathFromEncodedPolyline(encodedPolyline) {
        const result = [];

        const decodedPolyline = polyline.decode(encodedPolyline);
        for (const point of decodedPolyline) {
            var typeToUse = result.length == 0 ? BezierPathCommand.Type.MOVE_TO_POINT : BezierPathCommand.Type.ADD_LINE_TO_POINT;
            var command = new BezierPathCommand(typeToUse, new Point(point[1], point[0]));
            result.push(command);
        }

        return result;
    },

    getPointOnLinearBezier: function(point0, point1, percentageFromStart) {
        const x = BezierPathUtils._linearFormula(percentageFromStart, point0.x, point1.x);
        const y = BezierPathUtils._linearFormula(percentageFromStart, point0.y, point1.y);
        return new Point(x, y);
    },
    
    getPointOnQuadraticBezier: function(point0, point1, point2, percentageFromStart) {
        const x = BezierPathUtils._quadraticFormula(percentageFromStart, point0.x, point1.x, point2.x);
        const y = BezierPathUtils._quadraticFormula(percentageFromStart, point0.y, point1.y, point2.y);
        return new Point(x, y);
    },
    
    getPointOnCubicBezier: function(point0, point1, point2, point3, percentageFromStart) {
        const x = BezierPathUtils._cubicFormula(percentageFromStart, point0.x, point1.x, point2.x, point3.x);
        const y = BezierPathUtils._cubicFormula(percentageFromStart, point0.y, point1.y, point2.y, point3.y);
        return new Point(x, y);
    },
    
    _linearFormula: function(t, p0, p1) {
        return ((1 - t) * p0) + (t * p1);
    },
    
    _quadraticFormula: function(t, p0, p1, p2) {
        return (((1 - t) * (1 - t) * p0) + ((1 - t) * (1 - t) * t * p1)) + ((t * ( 1 - t) * p1) + (t * t * p2));
    },
    
    _cubicFormula(t, p0, p1, p2, p3) {
        return (Math.pow((1 - t), 3) * p0) + (3 * Math.pow((1 - t), 2) * t * p1) + (3 * (1 - t) * Math.pow(t,  2) * p2) + (Math.pow(t, 3) * p3);
    }
}

export default BezierPathUtils;
